/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Button, Spinner } from 'reactstrap';
import classnames from 'classnames';
import { ButtonProps } from 'reactstrap';

const LoadingButton = (props: ButtonProps) => {
  const { children, loading, block, loadingText, ...rest } = props;
  const style = { cursor: loading ? 'initial' : 'pointer' };

  return (
    <Button style={style} {...rest} block={block}>
      {block && loading ?
        (
          <>
            <Spinner
              className={classnames({
                'position-relative': true
              })}
              size='sm'
            />
            {loadingText}
          </>
        ) : (
          <span
            className={classnames({
              invisible: loading,
              visible: !loading,
              'span-style': !block
            })}
          >
            {children}
          </span>
        )}
    </Button>
  );
};
export default LoadingButton;
